import React, { Component } from "react";
import { Link } from "react-router-dom";
import Header from "../../layout/header";
import Footer from "../../layout/footer";
import MetaTags from "../../element/MetaTags";
import Menu from "./components/menu";
const bg = require("../../../images/servicehero.png");

class ResidentialCleaning extends Component {
  // componentDidMount() {
  //   // Scroll to the top as soon as the component mounts
  //   window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  // }

  render() {
    return (
      <>
        <MetaTags
          title="Residental Cleaning"
          description="Residental Cleaning"
          keywords="Residental Cleaning"
        />
        <Header />
        <div className="page-content bg-white">
          <div
            className="dlab-bnr-inr bg-pt"
            style={{ backgroundImage: "url(" + bg + ")" }}
          >
            <div className="container">
              <div className="dlab-bnr-inr-entry">
                <h1 className="text-white">Residental Cleaning</h1>
                <div className="breadcrumb-row">
                  {/* Breadcrumbs can be uncommented if needed */}
                </div>
              </div>
            </div>
          </div>

          <div className="content-block">
            <div className="section-full content-inner">
              <div className="container">
                <div className="row">
                  <Menu />
                  <div className="col-xl-9 col-lg-8 col-md-7 m-b30">
                    <div className="col-md-12 m-b30">
                      <div className="dlab-box">
                        {/* <div className="dlab-media">
                          <Link to="#">
                            <img
                              src={require("../../images/about/pic3.jpg")}
                              alt=""
                            />
                          </Link>
                        </div> */}
                        <div className="dlab-info ">
                          <h4 className="dlab-title m-t0">
                            <Link to="#">
                              Transform your home to a spotless space with
                              modern techniques at residential cleaning
                              services, Gold Coast, QLD
                            </Link>
                          </h4>
                          <p>
                            Customers with hectic schedules have little time for
                            house cleaning, and they might spend the only
                            weekend doing home chores. We can make it happen if
                            you have considered investing in a professional
                            residential cleaning service in Gold Coast. Kangaroo
                            Shine Property Services offer professional cleaning
                            services with customized cleaning plans to fit our
                            customers' needs at a reasonable cost.
                          </p>
                          <p>
                            Our trustworthy team of cleaning experts provides
                            you with the best full house cleaning while you can
                            enjoy your freedom and spend more time with your
                            loved ones.
                          </p>
                        </div>
                        <div className="dlab-info m-t30 ">
                          <h4 className="dlab-title m-t0">
                            <Link to="#">Conventional approaches</Link>
                          </h4>
                          <p>
                            In a modernizing world that evolves everyday, there
                            is no difference to cleaning. House cleaning methods
                            too have improved with advanced cleaning techniques,
                            specifically in the commercial sector. However,
                            still many of the traditional approaches are
                            practiced, and are effective. Modern technology only
                            makes these tasks more efficient, and is derived
                            from them.
                          </p>
                          <p>
                            For instance, traditional approaches for house
                            cleaning involve cleaning floors with a wet mop,
                            sweeping, scrubbing ingrained dirt or dusting with
                            cotton cloths. Modern techniques include mechanized
                            cleaning equipment such as varying types of vacuum
                            cleaners such as stick, robot, and backpack vacuums
                            which can trap even the minute allergens and dirt
                            which might circulate to cause allergies. On the
                            other hand, soaps and detergents have evolved to
                            eco-friendly products that claim to be safe for both
                            people and the environment with no added triclosan,
                            ammonia, parabens or phthalate.
                          </p>
                          <p>
                            We ensure our modern approach surpasses the
                            conventional; we at Gold Coast Kangaroo Shine
                            Property Services utilize sophisticated current
                            methods and techniques to deliver you and your
                            family a cleaner, healthier, and an efficient
                            environment.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="dlab-box">
                      <div className="dlab-info m-t30">
                        <h4 className="dlab-title m-t0 p-b2">
                          <Link to="#">
                            Elevated House Cleaning Process with Gold Coast
                            Kangaroo Shine Property Services
                          </Link>
                        </h4>
                        <p>
                          From dusting, linen changing, bed making, cleaning,
                          vacuuming, washing, tidying, and entire house
                          cleaning, our team of experts at Gold Coast Kangaroo
                          Shine Property Services is well-equipped with modern
                          and environmentally-friendly techniques to provide you
                          a beautifully transformed, spotless home. Residential
                          cleaning is not limited to a one-time cleaning, but it
                          ranges from recurring, occasional cleaning, apartment
                          cleaning, condo cleaning, moving cleaning, special
                          events, and eco-friendly cleaning.
                        </p>
                        <p>
                          If you are health-conscious, you are in the right
                          place! We specialize in sanitizing your home to
                          minimize germs and other contaminants to help prevent
                          flu, common colds, and respiratory illnesses from
                          presenting you with the hassle-free home you deserve.
                          Let us do the job where you can wake in the next
                          morning feeling refreshed!
                        </p>
                        <p>
                          Call or message us at +61424888804 to learn more about
                          our cost-effective daily, weekly, bi-weekly, or
                          contractual service at Kangaroo Shine Property
                          Services in Gold Coast, QLD.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </>
    );
  }
}

export default ResidentialCleaning;
